import { IconEye } from "@tabler/icons-react"
import { type FC } from "react"
import { Link } from "react-router"

import routes from "~/utilities/routes"

// Marks where the course's free preview ends, after the page above it. It's chosen in the course settings.
export const FreePreviewEnd: FC<{ courseId: number }> = ({ courseId }) => (
	<div className="text-primary flex items-center gap-3 py-1 text-sm font-medium">
		<div className="border-primary/40 flex-1 border-t-2 border-dashed" />
		<IconEye className="size-4 shrink-0" />
		<span className="whitespace-nowrap">Free preview ends here</span>
		<Link
			to={`${routes.course.settings(courseId)}#pricing`}
			className="hover:text-primary whitespace-nowrap text-gray-500 underline-offset-2 hover:underline"
		>
			Change
		</Link>
		<div className="border-primary/40 flex-1 border-t-2 border-dashed" />
	</div>
)
